export default __webpack_public_path__ + "static/media/card9.87fdbdda.jpg";